import * as React        from 'react';
import PropTypes         from 'prop-types';
import FieldsetComponent from './fieldset-component';

export default class FieldsetContainer extends React.Component {
	render() {
		return (
			<FieldsetComponent label={this.props.label}>
				{this.props.children}
			</FieldsetComponent>
		);
	}
}

FieldsetContainer.propTypes = {
	label: PropTypes.string.isRequired
}


// WEBPACK FOOTER //
// ./src/component/form/fieldset/fieldset-container.js